var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("select-input", {
    attrs: {
      name: "account-nav",
      required: "",
      selected: _vm.selected,
      options: _vm.options,
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }